module.exports = __webpack_public_path__ + "static/img/4-1-1.0d829d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-1-1.png
// module id = BCQs
// module chunks = 12